import { RetryButton } from './RetryButton';

type ErrorStateProps = {
  message: string;
  onRetry: () => void;
  retryAfter?: number | null;
  retryLabel?: string;
};

export function ErrorState({ message, onRetry, retryAfter = null, retryLabel }: ErrorStateProps) {
  return (
    <div className="flex min-h-[420px] items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-sm">
        <p className="text-base text-gray-700">{message}</p>
        <div className="mt-5 flex justify-center">
          <RetryButton retryAfter={retryAfter} onRetry={onRetry} label={retryLabel} />
        </div>
      </div>
    </div>
  );
}
